export type CountryCode = {
  code: string;
  dial: string;
};

export function getFlagUrl(code: string): string {
  return `https://flagcdn.com/w20/${code.toLowerCase()}.png`;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: "FR", dial: "+33" },
  { code: "BE", dial: "+32" },
  { code: "CH", dial: "+41" },
  { code: "LU", dial: "+352" },
  { code: "MC", dial: "+377" },
  { code: "DE", dial: "+49" },
  { code: "ES", dial: "+34" },
  { code: "IT", dial: "+39" },
  { code: "PT", dial: "+351" },
  { code: "NL", dial: "+31" },
  { code: "GB", dial: "+44" },
  { code: "US", dial: "+1" },
  { code: "CA", dial: "+1" },
  { code: "MA", dial: "+212" },
  { code: "DZ", dial: "+213" },
  { code: "TN", dial: "+216" },
];

export const DEFAULT_COUNTRY_CODE = COUNTRY_CODES[0];
